import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './bimmap.css';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

// Corrige os ícones padrão do Leaflet no bundler (webpack/CRA).
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl,
  shadowUrl,
});

// Pin colorido por tipo de entidade (pessoa/empresa).
export const makePinIcon = (color) =>
  L.divIcon({
    className: 'bimmap-pin',
    html: `<div style="width:22px;height:22px;background:${color};border:2px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.45)"></div>`,
    iconSize: [22, 22],
    iconAnchor: [11, 22],
    popupAnchor: [0, -22],
  });

export const PERSON_ICON = makePinIcon('#f97316');   // laranja
export const COMPANY_ICON = makePinIcon('#dc2626');  // vermelho

export default L;
